<template>
  <!--帖子列表页面-->
  <tk-container
    :status="status"
    hide-status-bar
    disable-scroll
  >
    <!--列表头部-->
    <grey-header slot="header" :title="$route.query.type === 'watch' ? '关注' : '粉丝'"></grey-header>
    <!--列表详情-->
    <tk-container
      infinite-scroll
      class="b-g-f"
      @loadingMore="getUserList"
    >
      <template v-if="watchPostUser.length">
        <div
          v-for="(s, index) in watchPostUser"
          :key="index"
        >
          <user-single :user-single="s" :type="$route.query.type" :profile-id="profileId"></user-single>
        </div>
      </template>
    </tk-container>
  </tk-container>
</template>

<script>
import userSingle from '@/components/userSingle'
import { judgePosts } from '@/assets/help/posts'
export default {
  components: {
    userSingle
  },
  data () {
    return {
      status: 'loading', // 页面状态
      watchPostUser: [] // 用户列表数组
    }
  },
  computed: {
    // 个人主页用户Id
    profileId () {
      return this.$route.query.id
    }
  },
  activated () {
    this.setStatusBar('dark')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/13
     */
    async getInit () {
      try {
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 获取发帖数·点赞数·及是否关注
     * @date: 2020/4/13
     */
    async dealWith (s) {
      s.postsSum = await this.statisticsNum('InformationPosts', { author: s.objectId })
      s.fansSum = await this.statisticsNum('watchPostUser', { author: s.objectId })
      if (this.$route.query.type === 'watch') {
        let watchStatus = await judgePosts('watchPostUser', { userFans: this.profileId, author: s.objectId })
        s.watchStatus = !!watchStatus
      } else {
        let watchStatus = await judgePosts('watchPostUser', { userFans: this.profileId, author: s.objectId })
        s.watchStatus = !!watchStatus
      }
      return s
    },
    /**
    * 用户列表信息
    * @date: 2020/4/13
    */
    async getUserList (page, next) {
      let type = this.$route.query.type
      let obj = {
        params: {
          limit: 10,
          skip: page * 10
        }
      }
      if (type === 'watch') {
        obj.params.include = ['author']
        obj.params.where = {
          userFans: this.profileId
        }
      } else {
        obj.params.include = ['userFans']
        obj.params.where = { author: this.profileId }
      }
      let userArr = []
      if (type === 'watch') {
        let watchPostUser = await this.$tkParse.getList(`/classes/watchPostUser`, obj)
        userArr = await Promise.all(watchPostUser.map(async s => {
          if (!s.author.avatar) { s.author.avatar = this.defaultImage }
          if (!s.author.name) { s.author.name = '用户' }
          s.user = await this.dealWith(s.author)
          return s.user
        }))
      } else {
        let watchPostUser = await this.$tkParse.getList(`/classes/watchPostUser`, obj)
        userArr = await Promise.all(watchPostUser.map(async s => {
          if (!s.userFans.avatar) { s.userFans.avatar = this.defaultImage }
          if (!s.userFans.name) { s.userFans.name = '用户' }
          s.userFans = await this.dealWith(s.userFans)
          return s.userFans
        }))
      }
      this.watchPostUser = [...this.watchPostUser, ...userArr]
      if (userArr.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
